<div class="bg-custom">
  <div class="container">
    <div class="subscreen-page">
      <!-- Header with Back Button -->
      <div class="page-header">
        <a
          (click)="goBack()"
          (keydown.enter)="goBack()"
          (keydown.space)="$event.preventDefault(); goBack()"
          role="button"
          tabindex="0"
          [attr.aria-label]="'BACK_TO_BUDGET_DETAILS' | globalTranslate"
        >
          <i class="fa fa-arrow-left me-2" aria-hidden="true"></i>
          <span>{{ "BACK_TO_BUDGET_DETAILS" | globalTranslate }}</span>
        </a>
      </div>
      <div class="page-title-section">
        <h2 class="page-title">
          {{ title | globalTranslate }}
          @if (titleTooltip) {
          <nh-popover [content]="titleTooltip | globalTranslate"></nh-popover>
          }
        </h2>
      </div>

      <!-- Info Section with Policy Links -->
      @if (infoText) {
      <div class="info-section">
        <p [innerHTML]="infoText | globalTranslate"></p>
      </div>
      }

      <!-- Content -->
      <div class="page-content">
        <div class="budget-calculation-box">
          <!-- Loop through all budget items with sections -->
          @for (item of items; track item) {
          <!-- Section Header (old style) -->
          @if (item?.isHeader) {
          <div class="section-header" role="heading" aria-level="3">
            {{ item.label | globalTranslate }}
          </div>
          }
          <!-- Section Divider Header (new style for deemed income) -->
          @if (item?.isSectionHeader) {
          <div class="section-header-row">
            <h4 class="section-header-title">
              {{ item.label | globalTranslate }}@if (item.label ===
              'DEEMED_INCOME_CHILD') {
              <span> {{ item?.amount }}:</span>
              }
            </h4>
          </div>
          }
          <!-- Regular Item Row -->
          @if (!item.isHeader && !item.isSectionHeader) {
          <div class="budget-item">
            <div
              class="budget-row"
              [class.total-row]="item?.isTotal"
              [class.result-row]="item?.isResult"
              [class.hide-on-mobile-when-expanded]="
                isExpanded(item?.id) &&
                !item?.isChildHeader &&
                item?.tableData &&
                item?.tableData.length > 0
              "
              [class.child-header-row]="item?.isChildHeader"
            >
              <!-- Expand Icon -->
              @if (item?.isExpandable) {
              <span
                class="expand-icon"
                (click)="toggleItem(item?.id)"
                (keydown.enter)="toggleItem(item?.id)"
                (keydown.space)="$event.preventDefault(); toggleItem(item?.id)"
                tabindex="0"
                role="button"
                [attr.aria-expanded]="isExpanded(item?.id)"
                [attr.aria-label]="item.label | globalTranslate"
              >
                @if (!isExpanded(item.id)) {
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                    fill="none"
                  />
                  <path
                    d="M10 6 L10 14 M6 10 L14 10"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                } @if (isExpanded(item.id)) {
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <circle
                    cx="10"
                    cy="10"
                    r="9"
                    stroke="currentColor"
                    stroke-width="1.5"
                    fill="none"
                  />
                  <path
                    d="M6 10 L14 10"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
                }
              </span>
              }
              <div class="budget-label">
                @if (!item?.isChildHeader) {
                <span>{{ item?.label | globalTranslate }}</span>
                } @if (item?.isChildHeader) {
                <span class="child-header-label">{{
                  item?.label | globalTranslate
                }}</span>
                } @if (item?.hasInfo && item?.tooltipText) {
                <nh-popover
                  [content]="item?.tooltipText | globalTranslate"
                ></nh-popover>
                }
              </div>
              @if (!item?.isChildHeader) {
              <div class="budget-value">
                @if (item?.operator) {
                <span class="operator-sign">{{ item.operator }}</span>
                } @if (item?.isCurrency !== false) {
                <span class="dollar-sign">$</span>
                } @if (item?.isCurrency === false) {
                <span
                  class="dollar-sign"
                  style="visibility: hidden"
                  aria-hidden="true"
                  >$</span
                >
                }
                <span class="amount-value" [class.pass-result]="item?.isResult">
                  {{ item?.isCurrency === false ? (typeof item?.amount === 'number' ? item?.amount : (item?.amount | globalTranslate)) : (typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate)) }}
                </span>
              </div>
              }
            </div>
            <!-- Expandable Table Data -->
            @if (isExpanded(item?.id) && item?.tableData?.length > 0) {
            <div class="detail-table-container" [@expandCollapse]>
              <!-- Desktop Table View -->
              <div
                class="budget-detail-table-wrapper d-none d-md-block"
                tabindex="0"
                role="region"
                [attr.aria-label]="
                  (item.label | globalTranslate) +
                  ' scrollable table ' +
                  item?.id
                "
              >
                <!-- Resource Table -->
                @if (isResourceTable(item)) {
                <table
                  class="budget-detail-table"
                  role="table"
                  [attr.aria-label]="
                    (item?.label | globalTranslate) + ' resource details table'
                  "
                >
                  <thead role="rowgroup">
                    <tr role="row">
                      <th scope="col" role="columnheader">
                        {{ "RESOURCE_TYPE" | globalTranslate }}
                      </th>
                      @if (item?.resourceType === 'nonLiquid') {
                      <th scope="col" role="columnheader">
                        {{ "DESCRIPTION" | globalTranslate }}
                      </th>
                      }
                      <th scope="col" role="columnheader">
                        {{ "VALUE" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "OWNER" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "PERCENT_OWNERSHIP" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "RES_EXCLUDED_AMOUNT" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    [@fadeInStagger]="item.tableData?.length || 0"
                    role="rowgroup"
                  >
                    @for (row of item.tableData; track row) {
                    <tr role="row">
                      <td role="cell">{{ row.resourceType }}</td>
                      @if (item?.resourceType === 'nonLiquid') {
                      <td role="cell">{{ row.description }}</td>
                      }
                      <td class="currency" role="cell">
                        ${{ row.value | number: "1.2-2" }}
                      </td>
                      <td role="cell">{{ row.owner }}</td>
                      <td role="cell">
                        {{ row.percentOwnership }}@if (row?.percentOwnership !==
                        'N/A') {
                        <span>%</span>
                        }
                      </td>
                      <td class="currency" role="cell">
                        ${{ row.excludedAmount | number: "1.2-2" }}
                      </td>
                      <td class="currency" role="cell">
                        ${{ row.countableAmount | number: "1.2-2" }}
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }
                <!-- Income Table -->
                @if (!isChildSupportTable(item.tableData) &&
                !isResourceTable(item)) {
                <table
                  class="budget-detail-table"
                  role="table"
                  [attr.aria-label]="
                    (item.label | globalTranslate) + ' income details table'
                  "
                >
                  <thead role="rowgroup">
                    <tr role="row">
                      <th scope="col" role="columnheader">
                        {{ "PERSON" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "TYPE" | globalTranslate }}
                      </th>
                      @if (item?.deemedIncomeTableType === 'abdDeemedIncome') {
                      <th scope="col" role="columnheader">
                        {{ "ADJUSTED_SPOUSE_AMOUNT" | globalTranslate }}
                      </th>
                      } @if (!item.deemedIncomeTableType) {
                      <th scope="col" role="columnheader">
                        {{ "AMOUNT" | globalTranslate }}
                      </th>
                      }
                      <th scope="col" role="columnheader">
                        {{ "EXCLUDED_AMOUNT" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    [@fadeInStagger]="item.tableData?.length || 0"
                    role="rowgroup"
                  >
                    @for (row of item.tableData; track row) {
                    <tr role="row">
                      <td role="cell">
                        <div class="person-cell">
                          <div class="person-name">{{ row.person }}</div>
                          @if (row.personId) {
                          <div class="person-meta">{{ row.personId }}</div>
                          }
                        </div>
                      </td>
                      <td role="cell">{{ row.type }}</td>
                      @if (item?.deemedIncomeTableType === 'abdDeemedIncome') {
                      <td role="cell" class="currency">
                        ${{ row.adjustedSpouseAmount | number: "1.2-2" }}
                      </td>
                      } @if (!item.deemedIncomeTableType) {
                      <td class="currency" role="cell">
                        ${{ row.amount | number: "1.2-2" }}
                      </td>
                      }
                      <td class="currency" role="cell">
                        ${{ row.excludedAmount | number: "1.2-2" }}
                      </td>
                      <td class="currency" role="cell">
                        ${{ row.countableAmount | number: "1.2-2" }}
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }
                <!-- Child Support Expenses Table -->
                @if (isChildSupportTable(item.tableData)) {
                <table
                  class="budget-detail-table"
                  role="table"
                  [attr.aria-label]="
                    (item.label | globalTranslate) +
                    ' child support details table'
                  "
                >
                  <thead role="rowgroup">
                    <tr role="row">
                      <th scope="col" role="columnheader">
                        {{ "PERSON" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "FOR_PERSON" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "AMOUNT" | globalTranslate }}
                      </th>
                      <th scope="col" role="columnheader">
                        {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                      </th>
                    </tr>
                  </thead>
                  <tbody
                    [@fadeInStagger]="item?.tableData?.length || 0"
                    role="rowgroup"
                  >
                    @for (row of item.tableData; track row) {
                    <tr role="row">
                      <td role="cell">
                        <div class="person-cell">
                          <div class="person-name">
                            {{ row.expensesPerson }}
                          </div>
                        </div>
                      </td>
                      <td role="cell">{{ row.expensesForPerson }}</td>
                      <td class="currency" role="cell">
                        ${{ row.expensesAmount | number: "1.2-2" }}
                      </td>
                      <td class="currency" role="cell">
                        ${{ row.expensesCountableAmount | number: "1.2-2" }}
                      </td>
                    </tr>
                    }
                  </tbody>
                </table>
                }
              </div>
              <!-- Mobile Card View -->
              <div
                class="mobile-card-container d-md-none"
                role="list"
                [attr.aria-label]="
                  (item.label | globalTranslate) + ' details list'
                "
              >
                <!-- Resource Mobile Cards -->
                <div
                  class="mobile-card-wrapper"
                  [hidden]="!isResourceTable(item)"
                >
                  <span
                    class="mobile-card-icon mobile_icon"
                    (click)="toggleItem(item.id)"
                    (keydown.enter)="toggleItem(item.id)"
                    (keydown.space)="
                      $event.preventDefault(); toggleItem(item.id)
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isExpanded(item?.id)"
                    [attr.aria-label]="item.label | globalTranslate"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <circle
                        cx="10"
                        cy="10"
                        r="9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M6 10 L14 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <div class="mobile-card">
                    <div class="mobile-card-header">
                      <div class="mobile-card-title">
                        <span>{{ item.label | globalTranslate }}</span>
                        @if (item?.hasInfo && item?.tooltipText) {
                        <nh-popover
                          [iconMode]="'transparent'"
                          [content]="item?.tooltipText | globalTranslate"
                          class="mobile-info-icon"
                        ></nh-popover>
                        }
                      </div>
                      <div class="mobile-card-amount">
                        <span class="dollar-sign" style="color: #ffffff"
                          >$</span
                        >
                        <span
                          >{{ typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate) }}</span
                        >
                      </div>
                    </div>
                    <div class="mobile-card-body">
                      @for (row of item.tableData; track row; let isLast =
                      $last) {
                      <ng-container role="listitem">
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "RESOURCE_TYPE" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{
                            row.resourceType
                          }}</span>
                        </div>
                        @if (item?.resourceType === 'nonLiquid') {
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "DESCRIPTION" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{
                            row.description
                          }}</span>
                        </div>
                        }
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "VALUE" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.value | number: "1.2-2" }}</span
                          >
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "OWNER" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{ row.owner }}</span>
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "PERCENT_OWNERSHIP" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >{{ row.percentOwnership }}@if
                            (row?.percentOwnership !== 'N/A') {
                            <span>%</span>
                            }</span
                          >
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "RES_EXCLUDED_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.excludedAmount | number: "1.2-2" }}</span
                          >
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "COUNTABLE_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.countableAmount | number: "1.2-2" }}</span
                          >
                        </div>
                        @if (!isLast) {
                        <hr class="mobile-card-divider" />
                        }
                      </ng-container>
                      }
                    </div>
                  </div>
                </div>
                <!-- Income Table Mobile Cards -->
                <div
                  class="mobile-card-wrapper"
                  [hidden]="
                    isChildSupportTable(item.tableData) || isResourceTable(item)
                  "
                >
                  <span
                    class="mobile-card-icon mobile_icon"
                    (click)="toggleItem(item.id)"
                    (keydown.enter)="toggleItem(item.id)"
                    (keydown.space)="
                      $event.preventDefault(); toggleItem(item.id)
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isExpanded(item?.id)"
                    [attr.aria-label]="item.label | globalTranslate"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <circle
                        cx="10"
                        cy="10"
                        r="9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M6 10 L14 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <div class="mobile-card">
                    <div class="mobile-card-header">
                      <div class="mobile-card-title">
                        <span>{{ item.label | globalTranslate }}</span>
                        @if (item?.hasInfo && item?.tooltipText) {
                        <nh-popover
                          [iconMode]="'transparent'"
                          [content]="item?.tooltipText | globalTranslate"
                          class="mobile-info-icon"
                        ></nh-popover>
                        }
                      </div>
                      <div class="mobile-card-amount">
                        <span class="dollar-sign" style="color: #ffffff"
                          >$</span
                        >
                        <span
                          >{{ typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate) }}</span
                        >
                      </div>
                    </div>
                    <div class="mobile-card-body">
                      @for (row of item.tableData; track row; let isLast =
                      $last) {
                      <ng-container role="listitem">
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "PERSON" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">
                            <div>
                              {{ row.person }}&nbsp;@if (row.personId) {
                              <span class="person-meta">{{
                                row.personId
                              }}</span>
                              }
                            </div>
                          </span>
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "TYPE" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{ row.type }}</span>
                        </div>
                        @if (item?.deemedIncomeTableType === 'abdDeemedIncome')
                        {
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "ADJUSTED_SPOUSE_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{
                              row.adjustedSpouseAmount | number: "1.2-2"
                            }}</span
                          >
                        </div>
                        } @if (!item?.deemedIncomeTableType) {
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.amount | number: "1.2-2" }}</span
                          >
                        </div>
                        }
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "EXCLUDED_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.excludedAmount | number: "1.2-2" }}</span
                          >
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "COUNTABLE_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.countableAmount | number: "1.2-2" }}</span
                          >
                        </div>
                        @if (!isLast) {
                        <hr class="mobile-card-divider" />
                        }
                      </ng-container>
                      }
                    </div>
                  </div>
                </div>
                <!-- Child Support Expenses Mobile Cards -->
                <div
                  class="mobile-card-wrapper"
                  [hidden]="!isChildSupportTable(item.tableData)"
                >
                  <span
                    class="mobile-card-icon mobile_icon"
                    (click)="toggleItem(item.id)"
                    (keydown.enter)="toggleItem(item.id)"
                    (keydown.space)="
                      $event.preventDefault(); toggleItem(item.id)
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isExpanded(item?.id)"
                    [attr.aria-label]="item.label | globalTranslate"
                  >
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <circle
                        cx="10"
                        cy="10"
                        r="9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M6 10 L14 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                  </span>
                  <div class="mobile-card">
                    <div class="mobile-card-header">
                      <div class="mobile-card-title">
                        <span>{{ item.label | globalTranslate }}</span>
                        @if (item?.hasInfo && item?.tooltipText) {
                        <nh-popover
                          [iconMode]="'transparent'"
                          [content]="item?.tooltipText | globalTranslate"
                          class="mobile-info-icon"
                        ></nh-popover>
                        }
                      </div>
                      <div class="mobile-card-amount">
                        <span class="dollar-sign" style="color: #ffffff"
                          >$</span
                        >
                        <span
                          >{{ typeof item?.amount === 'number' ? (item?.amount | number: '1.2-2') : (item?.amount | globalTranslate) }}</span
                        >
                      </div>
                    </div>
                    <div class="mobile-card-body">
                      @for (row of item.tableData; track row; let isLast =
                      $last) {
                      <ng-container role="listitem">
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "PERSON" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{
                            row.expensesPerson
                          }}</span>
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "FOR_PERSON" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value">{{
                            row.expensesForPerson
                          }}</span>
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{ row.expensesAmount | number: "1.2-2" }}</span
                          >
                        </div>
                        <div class="mobile-card-row">
                          <span class="mobile-card-label">{{
                            "COUNTABLE_AMOUNT" | globalTranslate
                          }}</span>
                          <span class="mobile-card-value"
                            >${{
                              row.expensesCountableAmount | number: "1.2-2"
                            }}</span
                          >
                        </div>
                        @if (!isLast) {
                        <hr class="mobile-card-divider" />
                        }
                      </ng-container>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
            }
            <!-- Expandable Nested Children Items -->
            @if (isExpanded(item.id) && item?.children?.length > 0) {
            <div class="nested-children-container" [@expandCollapse]>
              @for (childItem of item.children; track childItem) {
              <div class="budget-item nested-item">
                <div
                  class="budget-row"
                  [class.total-row]="childItem?.isTotal"
                  [class.result-row]="childItem?.isResult"
                  [class.hide-on-mobile-when-expanded]="
                    isExpanded(childItem.id)
                  "
                >
                  <!-- Expand Icon for nested items -->
                  @if (childItem?.isExpandable) {
                  <span
                    class="expand-icon"
                    (click)="toggleItem(childItem.id)"
                    (keydown.enter)="toggleItem(childItem.id)"
                    (keydown.space)="
                      $event.preventDefault(); toggleItem(childItem.id)
                    "
                    tabindex="0"
                    role="button"
                    [attr.aria-expanded]="isExpanded(childItem.id)"
                    [attr.aria-label]="childItem.label | globalTranslate"
                  >
                    @if (!isExpanded(childItem.id)) {
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <circle
                        cx="10"
                        cy="10"
                        r="9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M10 6 L10 14 M6 10 L14 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                    } @if (isExpanded(childItem.id)) {
                    <svg
                      width="20"
                      height="20"
                      viewBox="0 0 20 20"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <circle
                        cx="10"
                        cy="10"
                        r="9"
                        stroke="currentColor"
                        stroke-width="1.5"
                        fill="none"
                      />
                      <path
                        d="M6 10 L14 10"
                        stroke="currentColor"
                        stroke-width="2"
                        stroke-linecap="round"
                      />
                    </svg>
                    }
                  </span>
                  }
                  <div class="budget-label">
                    {{ childItem.label | globalTranslate }}
                    @if (childItem?.hasInfo && childItem?.tooltipText) {
                    <nh-popover
                      [content]="childItem?.tooltipText | globalTranslate"
                    ></nh-popover>
                    }
                  </div>
                  <div class="budget-value">
                    @if (childItem?.operator) {
                    <span class="operator-sign">{{ childItem.operator }}</span>
                    } @if (childItem?.isCurrency !== false) {
                    <span class="dollar-sign">$</span>
                    }
                    <span
                      class="amount-value"
                      [class.pass-result]="childItem?.isResult"
                    >
                      {{ childItem?.isCurrency === false ? (typeof childItem?.amount === 'number' ? childItem?.amount : (childItem?.amount | globalTranslate)) : (typeof childItem?.amount === 'number' ? (childItem?.amount | number: '1.2-2') : (childItem?.amount | globalTranslate)) }}
                    </span>
                  </div>
                </div>
                <!-- Expandable Table Data for nested items -->
                @if (isExpanded(childItem.id) && childItem?.tableData?.length >
                0) {
                <div class="detail-table-container" [@expandCollapse]>
                  <!-- Desktop Table View -->
                  <div
                    class="budget-detail-table-wrapper d-none d-md-block"
                    tabindex="0"
                    role="region"
                    [attr.aria-label]="
                      (childItem.label | globalTranslate) +
                      ' scrollable table ' +
                      childItem?.id
                    "
                  >
                    <!-- Income Table -->
                    <table
                      class="budget-detail-table"
                      role="table"
                      [attr.aria-label]="
                        (childItem.label | globalTranslate) +
                        ' income details table'
                      "
                    >
                      <thead role="rowgroup">
                        <tr role="row">
                          @if (!childItem?.hidePersonColumn) {
                          <th scope="col" role="columnheader">
                            {{ "PERSON" | globalTranslate }}
                          </th>
                          }
                          <th scope="col" role="columnheader">
                            {{ "TYPE" | globalTranslate }}
                          </th>
                          @if (childItem?.deemedIncomeTableType ===
                          'abdDeemedIncome') {
                          <th scope="col" role="columnheader">
                            {{ "ADJUSTED_SPOUSE_AMOUNT" | globalTranslate }}
                          </th>
                          } @if (!childItem?.deemedIncomeTableType) {
                          <th scope="col" role="columnheader">
                            {{ "AMOUNT" | globalTranslate }}
                          </th>
                          }
                          <th scope="col" role="columnheader">
                            {{ "EXCLUDED_AMOUNT" | globalTranslate }}
                          </th>
                          <th scope="col" role="columnheader">
                            {{ "COUNTABLE_AMOUNT" | globalTranslate }}
                          </th>
                        </tr>
                      </thead>
                      <tbody
                        [@fadeInStagger]="childItem.tableData?.length || 0"
                        role="rowgroup"
                      >
                        @for (row of childItem.tableData; track row) {
                        <tr role="row">
                          @if (!childItem?.hidePersonColumn) {
                          <td role="cell">
                            <div class="person-cell">
                              <div class="person-name">{{ row.person }}</div>
                              @if (row.personId) {
                              <div class="person-meta">{{ row.personId }}</div>
                              }
                            </div>
                          </td>
                          }
                          <td role="cell">{{ row.type }}</td>
                          @if (childItem?.deemedIncomeTableType ===
                          'abdDeemedIncome') {
                          <td role="cell" class="currency">
                            ${{ row.adjustedSpouseAmount | number: "1.2-2" }}
                          </td>
                          } @if (!childItem?.deemedIncomeTableType) {
                          <td role="cell" class="currency">
                            ${{ row.amount | number: "1.2-2" }}
                          </td>
                          }
                          <td class="currency" role="cell">
                            ${{ row.excludedAmount | number: "1.2-2" }}
                          </td>
                          <td class="currency" role="cell">
                            ${{ row.countableAmount | number: "1.2-2" }}
                          </td>
                        </tr>
                        }
                      </tbody>
                    </table>
                  </div>
                  <!-- Mobile Card View -->
                  <div
                    class="mobile-card-container d-md-none"
                    role="list"
                    [attr.aria-label]="
                      (childItem.label | globalTranslate) + ' details list'
                    "
                  >
                    @for (row of childItem.tableData; track row) {
                    <div class="mobile-card-wrapper">
                      <span
                        class="mobile-card-icon mobile_icon"
                        (click)="toggleItem(childItem.id)"
                        (keydown.enter)="toggleItem(childItem.id)"
                        (keydown.space)="
                          $event.preventDefault(); toggleItem(childItem.id)
                        "
                        tabindex="0"
                        role="button"
                        [attr.aria-expanded]="childItem?.isExpandable"
                        [attr.aria-label]="childItem.label | globalTranslate"
                      >
                        @if (childItem.isExpandable) {
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <circle
                            cx="10"
                            cy="10"
                            r="9"
                            stroke="currentColor"
                            stroke-width="1.5"
                            fill="none"
                          />
                          <path
                            d="M6 10 L14 10"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                        } @if (!childItem.isExpandable) {
                        <svg
                          width="20"
                          height="20"
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          aria-hidden="true"
                        >
                          <circle
                            cx="10"
                            cy="10"
                            r="9"
                            stroke="currentColor"
                            stroke-width="1.5"
                            fill="none"
                          />
                          <path
                            d="M6 10 L14 10"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                          <path
                            d="M10 6 L10 14"
                            stroke="currentColor"
                            stroke-width="2"
                            stroke-linecap="round"
                          />
                        </svg>
                        }
                      </span>
                      <div class="mobile-card">
                        <div class="mobile-card-header">
                          <div class="mobile-card-title">
                            <span>{{ childItem.label | globalTranslate }}</span>
                            @if (childItem?.hasInfo && childItem?.tooltipText) {
                            <nh-popover
                              [iconMode]="'transparent'"
                              [content]="
                                childItem?.tooltipText | globalTranslate
                              "
                              class="mobile-info-icon"
                            ></nh-popover>
                            }
                          </div>
                          <div class="mobile-card-amount">
                            <span class="dollar-sign" style="color: #ffffff"
                              >$</span
                            >
                            <span
                              >{{ typeof childItem?.amount === 'number' ? (childItem?.amount | number: '1.2-2') : (childItem?.amount | globalTranslate) }}</span
                            >
                          </div>
                        </div>
                        <div class="mobile-card-body">
                          @if (!childItem?.hidePersonColumn) {
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "PERSON" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value">{{
                              row.person
                            }}</span>
                          </div>
                          } @if (row.personId && !childItem?.hidePersonColumn) {
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "PERSON_ID" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value">{{
                              row.personId
                            }}</span>
                          </div>
                          }
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "TYPE" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value">{{
                              row.type
                            }}</span>
                          </div>
                          @if (childItem?.deemedIncomeTableType ===
                          'abdDeemedIncome') {
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "ADJUSTED_SPOUSE_AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{
                                row.adjustedSpouseAmount | number: "1.2-2"
                              }}</span
                            >
                          </div>
                          } @if (!childItem?.deemedIncomeTableType) {
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{ row.amount | number: "1.2-2" }}</span
                            >
                          </div>
                          }
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "EXCLUDED_AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{ row.excludedAmount | number: "1.2-2" }}</span
                            >
                          </div>
                          <div class="mobile-card-row">
                            <span class="mobile-card-label">{{
                              "COUNTABLE_AMOUNT" | globalTranslate
                            }}</span>
                            <span class="mobile-card-value"
                              >${{
                                row.countableAmount | number: "1.2-2"
                              }}</span
                            >
                          </div>
                        </div>
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
              </div>
              }
            </div>
            }
          </div>
          } }
        </div>
      </div>
    </div>
  </div>
</div>